module.exports = __webpack_public_path__ + "static/4f81f6.woff2";